import React, { useState } from 'react';
import { Button } from '@/components/ui/button';

export default function ActivityFormModal({ title, onClose, children, onSave, saveLabel = 'Save' }) {
    const [busy, setBusy] = useState(false);
    return (
        <div
            className="quick-create-popup-backdrop activity-modal-backdrop active"
            onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
        >
            <div
                className="activity-modal"
                role="dialog"
                aria-modal="true"
                aria-label={title}
                onClick={(e) => e.stopPropagation()}
            >
                <div className="activity-modal-header">
                    <h3>{title}</h3>
                </div>
                <div className="activity-modal-body">
                    {children}
                </div>
                <div className="activity-modal-footer">
                    <Button type="button" variant="secondary" className="btn btn-secondary" onClick={onClose} disabled={busy}>
                        Cancel
                    </Button>
                    <Button
                        type="button"
                        variant="default"
                        className="btn btn-primary"
                        disabled={busy}
                        onClick={async () => {
                            setBusy(true);
                            try {
                                const ok = await onSave();
                                if (ok !== false) onClose();
                            } finally {
                                setBusy(false);
                            }
                        }}
                    >
                        {saveLabel}
                    </Button>
                </div>
            </div>
        </div>
    );
}
